import type { GsEvent } from '@/lib/types';
import { formatEventDate } from '@/lib/format';
import DemoBadge from '@/components/feature/DemoBadge';

export default function EventInfo({ event }: { event: GsEvent }) {
  const rows = [
    { label: 'Date', value: formatEventDate(event.event_date) || `${event.weekday} ${event.month_label} ${event.day_label}, ${event.year_label}` },
    { label: 'Location', value: `${event.course}${event.city ? `, ${event.city}` : ''}` },
    { label: 'Entry fee', value: event.entry_fee || 'Contact organizer' },
    { label: 'Organizer', value: event.organizer || event.host || 'To be announced' },
    { label: 'Charity beneficiary', value: event.charity || 'To be announced' },
    { label: 'Format', value: `${event.event_type} tournament` },
  ];

  return (
    <section className="mt-12">
      <div className="flex flex-wrap items-center gap-3">
        <h2 className="font-heading font-extrabold uppercase text-3xl md:text-4xl">Tournament details</h2>
        {event.is_demo && <DemoBadge label="Sample tournament" />}
      </div>

      {event.description && <p className="mt-4 text-foreground-700 leading-relaxed max-w-3xl">{event.description}</p>}

      <dl className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-5 border-t border-background-200 pt-6">
        {rows.map((r) => (
          <div key={r.label}>
            <dt className="font-label uppercase tracking-widest text-xs text-foreground-500">{r.label}</dt>
            <dd className="mt-1 text-foreground-900 font-medium">{r.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}